import { MessageCircle } from "lucide-react";
import { useLeadModal } from "../../context/LeadModalContext";
import { FLOAT } from "../../constants/testIds";

export function FloatingCTA() {
	const { openLeadModal } = useLeadModal();
	return (
		<button
			data-testid={FLOAT.button}
			onClick={() => openLeadModal({ sourcePage: "Homepage" })}
			className="fixed bottom-5 right-5 z-40 group flex items-center gap-2 rounded-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white pl-4 pr-5 py-3 shadow-lg shadow-emerald-600/30 hover:shadow-emerald-600/50 hover:scale-105 transition-all"
		>
			<MessageCircle className="h-5 w-5" />
			<span className="font-semibold text-sm">Free Consultation</span>
		</button>
	);
}
